var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEspecialidadAzul(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_558200",
    "data-name": 558200,
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.312,
    height: 48.678,
    viewBox: "0 0 46.312 48.678",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_389",
    "data-name": "Grupo 389",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_388",
    "data-name": "Grupo 388"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_234",
    "data-name": "Trazado 234",
    d: "M53.163,13.336a5.493,5.493,0,0,0-.776,10.931V34.93a12.167,12.167,0,1,1-24.334,0v-2A14.925,14.925,0,0,0,42.184,18.05V4.714a2.355,2.355,0,0,0-2.357-2.357H38.256V1.571A1.572,1.572,0,0,0,36.684,0H35.113a1.572,1.572,0,0,0-1.571,1.571V4.714a1.572,1.572,0,0,0,1.571,1.571h1.571a1.572,1.572,0,0,0,1.571-1.571V3.928h1.571a.789.789,0,0,1,.786.786V18.059a13.352,13.352,0,0,1-.709,4.263,19.961,19.961,0,0,1-25.264,0,13.352,13.352,0,0,1-.709-4.263V4.714a.789.789,0,0,1,.786-.786h1.571v.786a1.572,1.572,0,0,0,1.571,1.571h1.552a1.572,1.572,0,0,0,1.571-1.571V1.571A1.566,1.566,0,0,0,19.411,0H17.84a1.572,1.572,0,0,0-1.571,1.571v.786H14.707A2.355,2.355,0,0,0,12.35,4.714V18.059A14.925,14.925,0,0,0,26.481,32.938v2a13.738,13.738,0,1,0,27.477,0V24.267a5.494,5.494,0,0,0-.8-10.931ZM36.684,4.714H35.113V1.571h1.571ZM17.84,1.571h1.571V4.714H17.84ZM16.01,25.187a21.347,21.347,0,0,0,22.514,0,13.31,13.31,0,0,1-22.514,0Zm37.163-2.424A3.928,3.928,0,1,1,57.1,18.835,3.933,3.933,0,0,1,53.172,22.763Z",
    transform: "translate(-12.35)",
    fill: "#409cce"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEspecialidadAzul);
export default __webpack_public_path__ + "static/media/especialidad-azul.baf1c55ee090a2e1ba85178dfc25d2e9.svg";
export { ForwardRef as ReactComponent };